export default Object.freeze({
  Open: 'OPEN',
  SentForExperienceRating: 'SENT_FOR_EXPERIENCE_RATING',
  ReadyToBeDelivered: 'READY_TO_BE_DELIVERED',
  OfferOfCoverageReadyToBeDelivered: 'OFFER_OF_COVERAGE_READY_TO_BE_DELIVERED',
  CreatedInOasis: 'CREATED_IN_OASIS',
});
